import { render, staticRenderFns } from "./CreationForm.vue?vue&type=template&id=77ef32c6&scoped=true&"
import script from "./CreationForm.vue?vue&type=script&lang=js&"
export * from "./CreationForm.vue?vue&type=script&lang=js&"
import style0 from "./CreationForm.vue?vue&type=style&index=0&id=77ef32c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ef32c6",
  null
  
)

export default component.exports